import React from 'react';
import classNames from 'classnames';
// import CurrencyInput from 'react-currency-input';

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import { useStyles } from './styles';

const CurrencyInputWrapper = ({
  input,
  label,
  isHiddenErrorMsg,
  className,
  meta: { touched, error },
  ...otherProps
}) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      <InputLabel
        className={classes.label}
        htmlFor={`${label}-currency-input`}
        disabled={otherProps.disabled}
        classes={{
          disabled: classes.disabledLabel
        }}
      >
        {label}
      </InputLabel>
      <input
        className={classNames(classes.input, {
          [classes.error]: touched && error
        })}
        type="number"
        {...input}
      />
      {/* <CurrencyInput
        className={classNames(classes.input, {
          [classes.error]: touched && error
        })}
        maxLength="14"
        decimalSeparator="."
        thousandSeparator=","
        precision="2"
        {...input}
      /> */}
      {!isHiddenErrorMsg && touched && error && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </div>
  );
};

export default CurrencyInputWrapper;
